//#region src/hooks/useCreateQueryKeys.ts
function e(e, t) {
	let n = {};
	for (let r in t) n[r] = (...n) => [e, ...t[r](...n)];
	return n;
}
//#endregion
export { e as useCreateQueryKeys };
